import { useState } from 'react';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { Icon } from '@/components/Icon';
import theme from '@/config/theme';
import dependencies from '@/assets/dependencies.json';
import { Section } from './Section';
import { SECTION_DATA } from './data';
import ProductInformations from '../ProductInformations/index';
import { styles } from './styles';

function AboutNeolexon() {
  const [expanded, setExpanded] = useState(false);

  return (
    <View style={styles.container}>
      {SECTION_DATA.map((section, index) => {
        const hasChildren = !!section.children;
        return (
          <Section key={index} title={section.title} content={section.content}>
            {hasChildren ? (
              <section.children.Component
                {...section.children.componentProps}
              ></section.children.Component>
            ) : null}
          </Section>
        );
      })}
      <Section
        title="Eingesetzte Software-Komponenten"
        bodyNode={
          <>
            <Text style={styles.slateText}>
              Im Folgenden finden Sie eine Übersicht der verwendeten
              Software-Komponenten von Drittanbietern. Diese sind erforderlich,
              um bestimmte Funktionen bereitzustellen und den sicheren und
              zuverlässigen Betrieb der Anwendung zu gewährleisten.
            </Text>
            <Pressable onPress={() => setExpanded((v) => !v)}>
              <View style={styles.row}>
                <Text style={styles.slateText}>
                  {expanded ? 'Ausblenden' : 'Anzeigen'}
                </Text>
                <Icon
                  name={expanded ? 'chevronDown' : 'chevronRight'}
                  size={20}
                  color={theme.colors.newUI.therapist.primaryBlue80}
                />
              </View>
            </Pressable>
            {expanded ? (
              <View style={styles.depList}>
                {dependencies.map((dep) => (
                  <Text key={dep} style={styles.slateText}>
                    {'• '}
                    {dep}
                  </Text>
                ))}
              </View>
            ) : null}
          </>
        }
      />
      <ProductInformations />
    </View>
  );
}

export default AboutNeolexon;
